import type { RequestStatus } from '@gestion-permisos/contracts';
import { STATUS_LABELS } from './format.js';

const STATUS_STYLES: Record<RequestStatus, string> = {
  DRAFT: 'bg-slate-100 text-slate-700',
  PENDING_APPROVAL: 'bg-amber-100 text-amber-800',
  APPROVED: 'bg-emerald-100 text-emerald-800',
  REJECTED: 'bg-red-100 text-red-800',
  CANCELLED: 'bg-slate-200 text-slate-600',
};

/** Colores `status-*` de la Power App (`src/components/status-badge.tsx`), definidos en `styles.css`. */
const STATUS_TOKEN_STYLES: Record<RequestStatus, string> = {
  DRAFT: 'bg-status-draft text-status-draft-foreground',
  PENDING_APPROVAL: 'bg-status-pending text-status-pending-foreground',
  APPROVED: 'bg-status-approved text-status-approved-foreground',
  REJECTED: 'bg-status-rejected text-status-rejected-foreground',
  CANCELLED: 'bg-status-cancelled text-status-cancelled-foreground',
};

/**
 * Insignia de estado. Con `tokens`, el aspecto de la Power App (lo usan las pantallas ya adaptadas); sin él,
 * el de siempre.
 */
export function StatusBadge({ status, tokens = false }: { status: RequestStatus; tokens?: boolean }) {
  const style = tokens
    ? `whitespace-nowrap rounded-md px-2.5 py-1 ${STATUS_TOKEN_STYLES[status]}`
    : `rounded-full px-2 py-0.5 ${STATUS_STYLES[status]}`;
  return <span className={`inline-block text-xs font-medium ${style}`}>{STATUS_LABELS[status]}</span>;
}
